import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Manifeste from "@/components/site/Manifeste";
import Catalogue from "@/components/site/Catalogue";
import Producteurs from "@/components/site/Producteurs";
import Contact from "@/components/site/Contact";
import MentionsLegales from "@/pages/MentionsLegales";

function Home() {
  return (
    <div className="App relative min-h-screen bg-[#050505] text-[#F5F5F0]">
      <Nav />
      <main>
        <Hero />
        <Manifeste />
        <Catalogue />
        <Producteurs />
        <Contact />
      </main>
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
